/* Stylesheet */

.options_label {
  margin: 0px 0px 46px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .label_container {
    display: flex;
    align-items: center;

    .icon {
      margin: 0px 8px 0px 0px;
      height: 21px;
      width: 21px;
      color: #ffffff;
    }

    .label {
      font-size: 1rem;
      color: var(--ion-color-text-secondary);
    }
  }
}
